// extracted by mini-css-extract-plugin
module.exports = {"outerDiv":"ContentDesktop_outerDiv__JqtJK","image":"ContentDesktop_image__1l_jd","title":"ContentDesktop_title__2uha7","contentDiv":"ContentDesktop_contentDiv__qPmzm"};